<template>
  <fragment>
    <thead>
      <tr>
        <th
          v-for="col in displayColumns"
          :key="col.id"
          @click="sortTable(col.id)"
        >
          {{ col.display }}
          <font-awesome-icon
            :icon="['fas', 'sort']"
            class="icon alt"
          />
          <span
            v-if="col.id == sortColumn"
            :class="ascending ? 'active-down' : 'active-up'"
          >
            <font-awesome-icon
              :icon="['fas', 'sort-down']"
              class="icon alt"
            />
            <font-awesome-icon
              :icon="['fas', 'sort-up']"
              class="icon alt"
            />
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="reportRecord in filteredReportData"
        :key="reportRecord.id"
      >
        <td
          v-for="col in displayColumns"
          :key="reportRecord.id + '-' + col.id"
          :style="col.style"
          :title=" col.title ? col.title(reportRecord[col.id], reportRecord) : null"
          :class="col.class"
        >
          <span
            v-if="col.isDownloadLink
              && reportRecord[col.id]"
            class="link"
            @click="downloadFile(reportRecord['id'])"
          >
            {{ col.format ? col.format(reportRecord[col.id]) : reportRecord[col.id] }}
          </span>
          <span v-else>
            {{ col.format ? col.format(reportRecord[col.id]) : reportRecord[col.id] }}
          </span>
          <label class="d-block d-md-none">{{ col.display }}</label>
        </td>
      </tr>
    </tbody>
    <tfoot v-if="reportData.length > recordsPerPage">
      <tr>
        <td :colspan="displayColumns.length">
          <b-pagination
            v-model="currentPage"
            :total-rows="reportData.length"
            :per-page="recordsPerPage"
            @change="pageChange"
          />
        </td>
      </tr>
    </tfoot>
  </fragment>
</template>

<script>
import paginationHelper from '../../common/paginationHelper';

/* eslint-disable vue/require-default-prop */
export default {
  name: 'TestFixtureResultsTable',
  props: {
    reportData: {
      type: Array,
    },
    downloadFile: {
      type: Function,
    },
  },
  emits: ['update-sort'],
  data: () => ({
    ascending: false,
    sortColumn: '',
    columns: [
      {
        id: 'serialNumber',
        display: 'Text Fixture SN',
      },
      {
        id: 'created',
        display: 'Reported Time',
        class: 'date-col',
        format: (v) => {
          const d = new Date(v);
          return d.toLocaleString();
        },
        title: (v) => {
          const d = new Date(v);
          return d.toUTCString();
        },
      },
      {
        id: 'testDate',
        display: 'Test Date',
        class: 'date-col',
        format: (v) => {
          const d = new Date(v);
          return d.toLocaleString();
        },
        title: (v) => {
          const d = new Date(v);
          return d.toUTCString();
        },
      },
      {
        id: 'cableSerialNumber',
        display: 'Cable SN',
      },
      {
        id: 'technicianId',
        display: 'Technician Id',
      },
      {
        id: 'overallResult',
        display: 'Overall Result',
      },

      {
        id: 'filename',
        display: 'Log File',
        isDownloadLink: true,
      },
    ],
    currentPage: 1,
    recordsPerPage: 50,
  }),
  computed: {
    filteredReportData() {
      return this.sortedData().slice(
        (this.currentPage - 1) * this.recordsPerPage,
        this.currentPage * this.recordsPerPage,
      ) || [];
    },
    displayColumns() {
      return this.columns
        .filter(x => x.id !== 'filename' || (this.$store.getters.isKgbAdminUser));
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$route.params': function () {
      this.handleRouteParams(this.$route.query);
    },
  },
  mounted() {
    this.handleRouteParams(this.$route.query);
  },
  methods: {
    handleRouteParams(queryParameterObject) {
      this.sortColumn = queryParameterObject.o;
      this.ascending = !!(queryParameterObject.a && queryParameterObject.a.toString() === 'true');
      this.currentPage = queryParameterObject.p || 1;
    },
    pageChange(page) {
      this.updateRoute(page, this.sortColumn, this.ascending);
    },
    updateRoute(page, column, ascending) {
      this.$router.push({
        query: { ...this.$route.query, ...paginationHelper(page, column, ascending) },
      });
    },
    sortedData() {
      if (!this.sortColumn) {
        return this.reportData;
      }
      return [...this.reportData].sort((a, b) => {
        if (a[this.sortColumn] === null) {
          return this.ascending ? 1 : -1;
        } if (b[this.sortColumn] === null) {
          return this.ascending ? -1 : 1;
        } if (a[this.sortColumn] > b[this.sortColumn]) {
          return this.ascending ? 1 : -1;
        } if (a[this.sortColumn] < b[this.sortColumn]) {
          return this.ascending ? -1 : 1;
        }
        return 0;
      });
    },
    sortTable: function sortTable(col) {
      if (this.sortColumn === col) {
        this.ascending = !this.ascending;
      } else {
        this.ascending = true;
        this.sortColumn = col;
      }
      this.updateRoute(this.currentPage, this.sortColumn, this.ascending);
      this.$emit('update-sort', { col: this.sortColumn, asc: `${this.ascending}` });
    },
  },
};
</script>

<style lang="scss" scoped>
  .date-col {
    min-width: 214px;
  }

</style>
